import React, { useState } from "react";

/**
 * TEMPORARY: shows the raw recognition-event log when the page was opened with ?speechdebug=1.
 * Renders nothing otherwise. Read-only; nothing leaves the device unless the person copies it.
 */
export function SpeechDebugPanel({ debug }) {
  const [copied, setCopied] = useState(false);
  if (!debug) return null;
  const text = debug.lines.join("\n");

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false); // the textarea below stays selectable for a manual copy
    }
  }

  return (
    <details open className="speech-debug" data-testid="speech-debug" style={{ margin: "12px 0", padding: 10, border: "1px dashed #c9a84c", borderRadius: 10, fontSize: 12 }}>
      <summary style={{ cursor: "pointer", fontWeight: 700 }}>Speech diagnostics ({debug.lines.length} lines)</summary>
      <div style={{ display: "flex", gap: 8, margin: "8px 0" }}>
        <button type="button" onClick={copy}>{copied ? "Copied" : "Copy log"}</button>
        <button type="button" onClick={() => { debug.clear(); setCopied(false); }}>Clear</button>
      </div>
      <textarea readOnly value={text} rows={10} aria-label="Speech recognition event log" style={{ width: "100%", fontFamily: "monospace", fontSize: 11 }} />
    </details>
  );
}
